import React from 'react';
import PropTypes from 'prop-types';
import { GRAPH_STATUSES } from '../../constants/constants';
import ReactTooltip from "react-tooltip";
import './Graph100StackedBar.scss';

const Graph100StackedBar = ({ data, onClick }) => {

    const renderColoredSections = () => {
        let slices = []
        if (data && data.length) {
            const total = (data.find(m => m.id === GRAPH_STATUSES.NotApplicable.label).value
                + data.find(m => m.id === GRAPH_STATUSES.Complete.label).value
                + data.find(m => m.id === GRAPH_STATUSES.PastDue.label).value
                + data.find(m => m.id === GRAPH_STATUSES.InProgress.label).value
                + data.find(m => m.id === GRAPH_STATUSES.NotDue.label).value
            );

            const valuedData = data.filter(x => x.value > 0);
            let currentx = 0;
            for (let i = 0; i < valuedData.length; i++) {
                const point = valuedData[i];

                if (point && point.value) {
                    // Determine which color to render this data point
                    let color = null;
                    for (let prop in GRAPH_STATUSES) {
                        if (Object.prototype.hasOwnProperty.call(GRAPH_STATUSES, prop) && GRAPH_STATUSES[prop].label === point.id) {
                            color = GRAPH_STATUSES[prop].color;
                            break;
                        }
                    }

                    const percentage = (point.value / total) * 100;

                    slices.push(<rect 
                        key={point.id}
                        x={currentx} 
                        width={percentage.toFixed(2) + "%"} 
                        height="22"
                        fill={color}
                        style={
                            { cursor: "pointer"}
                        }
                        onClick={() => onClick(point)}
                    />);

                    currentx += 400 * (percentage.toFixed(2) / 100);

                }
            }
        }
        return slices;
    }

    const renderNumbers = () => {
        let slices = []
        if (data && data.length) {
            const total = (data.find(m => m.id === GRAPH_STATUSES.NotApplicable.label).value
                + data.find(m => m.id === GRAPH_STATUSES.Complete.label).value
                + data.find(m => m.id === GRAPH_STATUSES.PastDue.label).value
                + data.find(m => m.id === GRAPH_STATUSES.InProgress.label).value
                + data.find(m => m.id === GRAPH_STATUSES.NotDue.label).value
            );

            const valuedData = data.filter(x => x.value > 0);
            for (let i = 0; i < valuedData.length; i++) {
                const point = valuedData[i];

                if (point && point.value) {

                    const percentage = (point.value / total) * 100;
                    slices.push(<span key={point.id} className="graph-slice-value"
                        style={
                            {
                                marginTop: '5px',
                                width: `${percentage}%`,
                                display: "inline-block",
                                textAlign: "center",
                                cursor: "pointer"
                            }}
                        onClick={() => onClick(point)}>
                        {point.value}
                    </span>);
                }
            }
        }
        return slices;
    }

    return (
        <div className="graph-hundyp-stacked-bar-container">
            <div className="graph-hundyp-stacked-bar">
                <svg xmlns="http://www.w3.org/2000/svg" role="img" width="400" height="22px" viewBox="0 0 400 22">
                    {renderColoredSections()}
                </svg>
                {renderNumbers()}
            </div>
            <ReactTooltip />
        </div>
    );

};
Graph100StackedBar.propTypes = {
    data: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired
};

export default Graph100StackedBar;